import React from 'react';
import { Layout } from '../components/Layout';
export function PrivacyPolicy() {
  return <Layout data-id="element-58">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-59">
        <h1 className="text-3xl font-bold text-[#0A1D37] mb-8" data-id="element-60">
          Privacy Policy
        </h1>
        <div className="prose prose-lg max-w-none" data-id="element-61">
          <p className="text-gray-600 mb-8" data-id="element-62">
            Last Updated:{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          </p>
          <section className="mb-10" data-id="element-63">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-64">
              Introduction
            </h2>
            <p className="mb-4" data-id="element-65">
              At Forgepoint Management LLC, we respect your privacy and are
              committed to protecting your personal data. This privacy policy
              will inform you about how we look after your personal data when
              you visit our website and tell you about your privacy rights and
              how the law protects you.
            </p>
          </section>
          <section className="mb-10" data-id="element-66">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-67">
              Information We Collect
            </h2>
            <p className="mb-4" data-id="element-68">
              We may collect, use, store, and transfer different kinds of
              personal data about you which we have grouped together as follows:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-69">
              <li data-id="element-70">
                <strong data-id="element-71">Identity Data</strong> includes first name, last name,
                username or similar identifier.
              </li>
              <li data-id="element-72">
                <strong data-id="element-73">Contact Data</strong> includes email address, telephone
                numbers, and physical address.
              </li>
              <li data-id="element-74">
                <strong data-id="element-75">Technical Data</strong> includes internet protocol (IP)
                address, browser type and version, time zone setting and
                location, browser plug-in types and versions, operating system
                and platform, and other technology on the devices you use to
                access this website.
              </li>
              <li data-id="element-76">
                <strong data-id="element-77">Usage Data</strong> includes information about how you
                use our website and services.
              </li>
              <li data-id="element-78">
                <strong data-id="element-79">Property Data</strong> includes information about
                properties you submit for evaluation, including address,
                condition, and estimated values.
              </li>
            </ul>
          </section>
          <section className="mb-10" data-id="element-80">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-81">
              How We Use Your Data
            </h2>
            <p className="mb-4" data-id="element-82">
              We use your personal data for the following purposes:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-83">
              <li data-id="element-84">
                To manage our relationship with you, including notifying you
                about changes to our terms or privacy policy.
              </li>
              <li data-id="element-85">To process and deliver our services to you.</li>
              <li data-id="element-86">
                To store your information in our internal Customer Relationship
                Management (CRM) system.
              </li>
              <li data-id="element-87">
                To contact you regarding properties, services, or information
                you have requested from us.
              </li>
              <li data-id="element-88">
                To send you marketing communications via email that may be of
                interest to you.
              </li>
              <li data-id="element-89">
                To send you SMS messages regarding your inquiries, property
                offers, or related updates (see our{' '}
                <a href="/sms-policy" className="text-[#10B981] hover:text-[#0DD393]" data-id="element-90">
                  SMS Opt-In Policy
                </a>{' '}
                for more details).
              </li>
              <li data-id="element-91">
                To improve our website, products/services, marketing, or
                customer relationships.
              </li>
            </ul>
          </section>
          <section className="mb-10" data-id="element-92">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-93">
              Third-Party Data Sharing
            </h2>
            <p className="mb-4" data-id="element-94">
              We may share your personal data with the following third parties:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-95">
              <li data-id="element-96">
                Service providers who provide IT and system administration
                services.
              </li>
              <li data-id="element-97">
                Professional advisers including lawyers, bankers, auditors, and
                insurers.
              </li>
              <li data-id="element-98">
                Regulators and other authorities who require reporting of
                processing activities in certain circumstances.
              </li>
              <li data-id="element-99">
                Third-party service providers who assist us in processing
                property information and providing cash offers.
              </li>
            </ul>
            <p className="mb-4" data-id="element-100">
              We require all third parties to respect the security of your
              personal data and to treat it in accordance with the law. We do
              not allow our third-party service providers to use your personal
              data for their own purposes and only permit them to process your
              personal data for specified purposes and in accordance with our
              instructions.
            </p>
          </section>
          <section className="mb-10" data-id="element-101">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-102">
              Your Rights and Choices
            </h2>
            <p className="mb-4" data-id="element-103">You have the right to:</p>
            <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-104">
              <li data-id="element-105">
                <strong data-id="element-106">Access</strong> - You can request copies of your
                personal data.
              </li>
              <li data-id="element-107">
                <strong data-id="element-108">Rectification</strong> - You can request that we correct
                any information you believe is inaccurate or complete
                information you believe is incomplete.
              </li>
              <li data-id="element-109">
                <strong data-id="element-110">Erasure</strong> - You can request that we erase your
                personal data, under certain conditions.
              </li>
              <li data-id="element-111">
                <strong data-id="element-112">Restrict processing</strong> - You can request that we
                restrict the processing of your personal data, under certain
                conditions.
              </li>
              <li data-id="element-113">
                <strong data-id="element-114">Object to processing</strong> - You can object to our
                processing of your personal data, under certain conditions.
              </li>
              <li data-id="element-115">
                <strong data-id="element-116">Data portability</strong> - You can request that we
                transfer the data we have collected to another organization, or
                directly to you, under certain conditions.
              </li>
            </ul>
            <p className="mb-4" data-id="element-117">
              To exercise any of these rights, please contact us at
              privacy@forgepointmanagement.com. We may need to request specific
              information from you to help us confirm your identity.
            </p>
          </section>
          <section className="mb-10" data-id="element-118">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-119">
              Opting Out and Data Deletion
            </h2>
            <p className="mb-4" data-id="element-120">
              You can opt out of receiving marketing communications from us at
              any time by:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-121">
              <li data-id="element-122">
                Clicking the "unsubscribe" or "opt-out" link in any marketing
                email we send you
              </li>
              <li data-id="element-123">Contacting us at privacy@forgepointmanagement.com</li>
              <li data-id="element-124">
                For SMS communications, reply "STOP" to any message you receive
                from us (see our{' '}
                <a href="/sms-policy" className="text-[#10B981] hover:text-[#0DD393]" data-id="element-125">
                  SMS Opt-In Policy
                </a>{' '}
                for more details)
              </li>
            </ul>
            <p className="mb-4" data-id="element-126">
              To request deletion of your personal data, please email us at
              privacy@forgepointmanagement.com with the subject line "Data
              Deletion Request". We will respond to your request within 30 days.
            </p>
          </section>
          <section className="mb-10" data-id="element-127">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-128">
              Compliance Statement
            </h2>
            <p className="mb-4" data-id="element-129">
              Forgepoint Management LLC is committed to ensuring that our
              privacy practices comply with applicable data protection laws and
              regulations, including:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-130">
              <li data-id="element-131">
                <strong data-id="element-132">General Data Protection Regulation (GDPR)</strong> - For
                users in the European Union, we comply with the GDPR
                requirements regarding the collection, use, and retention of
                personal data.
              </li>
              <li data-id="element-133">
                <strong data-id="element-134">Telephone Consumer Protection Act (TCPA)</strong> - We
                adhere to TCPA regulations regarding telephone communications,
                text messages, and fax communications.
              </li>
              <li data-id="element-135">
                <strong data-id="element-136">California Consumer Privacy Act (CCPA)</strong> - For
                California residents, we comply with the CCPA regarding the
                collection, use, and disclosure of personal information.
              </li>
            </ul>
          </section>
          <section className="mb-10" data-id="element-137">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-138">
              Changes to This Privacy Policy
            </h2>
            <p className="mb-4" data-id="element-139">
              We may update our privacy policy from time to time. We will notify
              you of any changes by posting the new privacy policy on this page
              and updating the "Last Updated" date at the top of this policy.
            </p>
            <p className="mb-4" data-id="element-140">
              You are advised to review this privacy policy periodically for any
              changes. Changes to this privacy policy are effective when they
              are posted on this page.
            </p>
          </section>
          <section data-id="element-141">
            <h2 className="text-2xl font-semibold text-[#0A1D37] mb-4" data-id="element-142">
              Contact Us
            </h2>
            <p className="mb-4" data-id="element-143">
              If you have any questions about this privacy policy or our privacy
              practices, please contact us at:
            </p>
            <div className="bg-[#E2E8F0] p-4 rounded-lg" data-id="element-144">
              <p className="mb-1" data-id="element-145">
                <strong data-id="element-146">Forgepoint Management LLC</strong>
              </p>
              <p className="mb-1" data-id="element-147">Email: privacy@forgepointmanagement.com</p>
              <p className="mb-1" data-id="element-148">Phone: (555) 123-4567</p>
            </div>
          </section>
        </div>
      </div>
    </Layout>;
}